import { Routes } from '@angular/router';

export const PROVEEDORES_ROUTES: Routes = [
  {
    path: 'listar',
    loadComponent: () =>
      import('./listar/proveedor-listar.component')
        .then(m => m.ProveedorListarComponent)
  },
  {
    path: 'crear',
    loadComponent: () =>
      import('./crear/proveedor-crear.component')
        .then(m => m.ProveedorCrearComponent)
  },
  {
    path: 'editar/:id',
    loadComponent: () =>
      import('./editar/proveedor-editar-component.component')
        .then(m => m.ProveedorEditarComponentComponent)
  },
  {
    path: ':id',
    loadComponent: () =>
      import('./detalle/proveedor-detalle.component')
        .then(m => m.ProveedorDetalleComponent)
  }
];
